import { Col, Container, Image, Row } from 'react-bootstrap';
import IllustrationImage from 'assets/img/landing/aboutUsIllustration.png';

function About() {
  return (
    <Container fluid className="px-lg-14 pb-14 bg-body-highlight">
      <p className="fs-4 text-center fw-bold py-6">
        About <span className="text-secondary-light">Us</span>
      </p>
      <Row>
        <Col lg={2}>
          <p>
            What Makes <br />
            Us <br />
            Unique.
          </p>
        </Col>
        <Col lg={9}>
          <p>
            At Crud Beat, we believe in bridging the gap between talent and
            opportunity. As a premier platform for hiring and training, we
            empower institutions, students, and employers to succeed in today’s
            competitive landscape. Our mission is to create a seamless,
            efficient, and engaging experience that transforms potential into
            excellence.
          </p>
        </Col>
      </Row>
      <Row className="d-flex justify-content-end">
        <Col lg={10}>
          <Image
            src={IllustrationImage}
            alt="IllustrationImage"
            width="100%"
            className="mt-5"
          />
        </Col>
      </Row>
    </Container>
  );
}

export default About;
